import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Fab } from 'src/components/Fab';
import { Icon } from 'src/components/Icon';
import { LeaderboardAgeFilter } from 'src/models/leaderboard/_types';

import { LeaderboardFiltersModal } from './LeaderboardFiltersModal';
import { useLeaderboardFilters } from './useLeaderboardFilters';

interface LeaderboardFilterButtonProps {
  availableFilters: string[];
  ageFilters?: LeaderboardAgeFilter[];
}

export const LeaderboardFilterButton = ({
  availableFilters,
  ageFilters = [],
}: LeaderboardFilterButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'leaderboard.public.filters',
  });
  const [open, setOpen] = useState(false);
  const { filters } = useLeaderboardFilters();

  let activeCount = 0;
  if (filters.locationIds?.length || filters.locationId) activeCount++;
  if (filters.locationTags?.length) activeCount++;
  if (filters.ageMin || filters.ageMax) activeCount++;
  if (filters.gender) activeCount++;

  return (
    <>
      <Fab
        variant="extended"
        color="primary"
        size="medium"
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10,
        }}
      >
        <Box component="span" sx={{ mr: 1, display: 'inline-flex' }}>
          <Icon icon={faFilter} />
        </Box>
        {t('title')}
        {activeCount > 0 && ` (${activeCount})`}
      </Fab>
      <LeaderboardFiltersModal
        open={open}
        onClose={() => setOpen(false)}
        availableFilters={availableFilters}
        ageFilters={ageFilters}
      />
    </>
  );
};
